import 'babel-polyfill';
import Vue from 'vue';
import color from '@/mixins/color';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import './lib/ol.css';
import 'lodash';
import App from './App.vue';
import store from './store';

const $ = require('jquery');

window.$ = $;

Vue.use(Vuetify);

Vue.config.productionTip = false;
Vue.config.devtools = true;

const appColours = {
  primary: '#263746',
  gx_green: '#a1d0ca',
  secondary: '#a1d0ca',
  accent: '#d8d1ca',
  gx_beige: '#d8d1ca',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  gx_grey: '#e4e4e4',
};

const vuetifyOpts = {
  icons: {
    iconfont: 'mdi',
  },
  breakpoint: {
    mobileBreakpoint: 'xs'
  },
  theme: {
    dark: false,
    themes: {
      dark: appColours,
      light: appColours,
    },
  },
};

Vue.mixin(color);

new Vue({
  el: '#app',
  vuetify: new Vuetify(vuetifyOpts),
  store,
  components: { App },
  template: '<App/>',
});
